import { Dispatch } from 'redux';

import { requestHandler } from '../../../api';

export const getAllFactoringExtensions = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/extension/factoring?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getFactoringExtension = async (dispatch: Dispatch, id: string) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/extension/factoring/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const updateFactoringExtensionParams = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/extension/factoring/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const createFactoringExtension = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/extension/factoring`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentWithExtensionData = async (
  dispatch: Dispatch,
  id: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/extension/factoring/documents/${id}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getAvailableDocumentsForFactoringExtension = async (
  dispatch: Dispatch,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/extension/factoring/documents`,
    dispatch,
  });
  if (response) return response.data;
};

export const approveFactoringExtension = async (
  dispatch: Dispatch,
  id: string,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/extension/factoring/${id}/approve`,
    dispatch,
  });
  if (response) return response.data;
};

export const getExtensionFactoringMissingApprovals = async (
  dispatch: Dispatch,
  id: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/extension/factoring/${id}/approvals`,
    dispatch,
  });
  if (response) return response.data;
};

export const approveExtension = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/extension/factoring/${id}/approve`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const rejectExtension = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/extension/factoring/${id}/reject`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const editExtensionRequestComitee = async (
  dispatch: Dispatch,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/extension/comitee/${id}`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
